// extracted by mini-css-extract-plugin
module.exports = {"controls":"CommentEdit_controls__I9a8z","field":"CommentEdit_field__9R4Ys"};